<div class="flex-1 bg-white rounded shadow-xl rounded-xl" [class]="cssClass()">
  <div class="py-6 px-2 flex flex-col h-full">
    <div class="mb-8">
      <div class="flex justify-between items-center mb-8">
        <span class="text-2xl font-bold text-primary">{{ chartHeader() }}</span>
      </div>
      <hr class="border-gray-300" />
    </div>

    <div class="card-body">
      <div class="flex flex-wrap gap-4 mb-3">
        <div
          class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-center gap-3 w-full"
        >
          @for(filter of filterOptions(); track $index) {
          <div class="flex flex-col flex-wrap gap-1 items-center">
            <label>{{ filter.label! }}:</label>
            @if (filter.key === "multiGroups"){
            <p-multiselect
              [options]="filter.dropdownOptions"
              [placeholder]="
                filter.dropdownOptions.length
                  ? (filter.dropdownOptions[0].label)
                  : ''
              "
              [(ngModel)]="selectedFilters[filter.key]"
              (onChange)="onDropdownChange($event, filter.key)"
              (onClear)="resetFilter(filter.key)"
              [showToggleAll]="false"
              [fluid]="true"
              class="w-full"
              appendTo="body"
              [showClear]="true"
            />
            }@else if( filter.key === "group" || filter.key === "kenCodes" || filter.key === "kenCode" ||
                        filter.key === "admissionICD10s" || filter.key === "dischargeICD10s" ||
                        filter.key === 'clinic') {
              <p-select
                [options]="filter.dropdownOptions"
                [placeholder]="
                  filter.dropdownOptions.length
                    ? (filter.dropdownOptions[0].label)
                    : ''
                "
                [filter]="true"
                filterBy="label"  
                [(ngModel)]="selectedFilters[filter.key]"
                (onChange)="onDropdownChange($event, filter.key)"
                [fluid]="true"
                class="w-full" 
                appendTo="body"
                [showClear]="true"
              />
            } @else{
            <p-select
              [options]="filter.dropdownOptions"
              [placeholder]="
                filter.dropdownOptions.length
                  ? (filter.dropdownOptions[0].label)
                  : ''
              "
              [(ngModel)]="selectedFilters[filter.key]"
              (onChange)="onDropdownChange($event, filter.key)"
              [fluid]="true"
              class="w-full"
              appendTo="body"
              [showClear]="true"
            ></p-select>
            }
          </div>
          }
        </div>
      </div>
      <div #chartRef [style.height]="'100%'">
        <ng-content select="[chart-content]"></ng-content>
      </div>
      <ng-content select="[chart-stats]"></ng-content>
    </div>
  </div>
</div>
